<template>
	<div class="am-gallery" :style="{ backgroundImage: `url(${images[0]})` }">
		<am-icon class="am-gallery__fullscreen" :dark="true" name="fullscreen" size="sm" @click.native="$emit('open', images)" />
	</div>
</template>

<script>
import AMIcon from '@/components/atoms/AMIcon'

export default {
	components: {
		'am-icon': AMIcon
	},

	props: {
		images: {
			type: Array,
			default: () => ([
				'https://placeimg.com/640/480/any'
			])
		}
	}
}
</script>

<style lang="scss">
.am-gallery{
	background-size: cover;
	background-position: center;
	position: relative;
	&:after{
		content: "";
		display: block;
		padding-top: 60%;
	}
	&__fullscreen{
		position: absolute;
		top: 16px;
		right: 16px;
		width: 32px;
		height: 32px;
		background: rgba(black, .6);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: .2s $easeInOutQuad;
		&:hover{
			background: rgba(black, .8);
		}
	}
}
</style>
